<template>
    <div>
        <Project  :client="client"
                  :product="product"
                  :tasks="tasks"
        />
        <transition appear name="slide-bot">
            <section class="grid-section" id="project-intro">
                <a href="#" v-scroll-to="'#project-content'" class="scroll-arrow">
                    <svg width="10px" height="72px" viewBox="0 0 10 72" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="arrow-down" fill-rule="nonzero">
                                <polygon id="arrow-copy" transform="translate(4.535534, 36.000347) rotate(-270.000000) translate(-4.535534, -36.000347) " points="38.6565072 36.4648132 -31.464119 36.4648132 -31.464119 35.4648132 38.5854393 35.4648132 35.2925461 32.17192 35.9996529 31.4648132 40.5351868 36.0003471 35.9996529 40.535881 35.2925461 39.8287743"></polygon>
                            </g>
                        </g>
                    </svg>
                </a>
            </section>
        </transition>
        <section class="grid-section" id="project-content">
            <img class="ipad" src="@/assets/img/sac/sac-rentables-ipad.png" />
            <img class="site" src="@/assets/img/sac/sac-home.jpg" />
        </section>
        <section class="grid-section" id="project-content-2">
            <img class="ipad" src="@/assets/img/sac/sac-sidebar-ipad.png" />
            <img class="site" src="@/assets/img/sac/sac-home-sidebar.jpg" />
        </section>
        <section class="grid-section" id="project-content-3">
            <img class="ipad" src="@/assets/img/sac/sac-lage-ipad.png" />
            <img class="site" src="@/assets/img/sac/sac-object-single.jpg" />
        </section>
    </div>
</template>

<script>
    import Project from "@/components/Project.vue";

    export default {
        name: "sac",
        components: {
            Project
        },
        data () {
            return {
                client: "Stuttgart Airport City",
                product: "Online Presence",
                tasks: {
                    task1: "Art Direction",
                    task2: "UX Design",
                }
            }
        }
    };
</script>

<style scoped>
    #project-intro
    {
        margin-bottom: 0;
        background-image: url("../assets/img/sac/sac-intro.jpg");
        background-size: cover;
    }

    .scroll-arrow {
        grid-column: 1 / 2;
        grid-row: 5 / 6;
        padding-right: 1.4rem;
        padding-left: 1.4rem;
        justify-self: right;
        align-self: end;
    }

    #project-intro .scroll-arrow g {
        fill: rgb(64,64,64);
    }

    #project-intro img {
        grid-column: 2 / 6;
        grid-row: 2 / 6;
        filter: drop-shadow(0 0.5rem 1.5rem rgba(0,0,0,0.25));
        max-width:60vw;
        justify-self: center;
        align-self: center;
    }

    #project-content {
        height: auto;
        background-image: url("../assets/img/sac/sac-bg-1.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        background-color: rgba(255,255,255,1);
        padding-bottom: 20vh;
        padding-top: 20vh;
        margin-bottom: 0;
    }

    .ipad {
        width: 100%;
        z-index: 1;
        filter: drop-shadow(1rem 1rem 1.5rem rgba(0,0,0,0.5));
    }

    .site {
        width: 100%;
        filter: drop-shadow(0 0.5rem 1.5rem rgba(0,0,0,0.25));
    }

    #project-content .ipad {
        grid-column: 2 / 4;
        grid-row: 4 / 7;
    }

    #project-content .site {
        grid-column: 3 / 6;
        grid-row: 1 / 7;
    }

    #project-content-2 {
        height: auto;
        background-color: rgba(255,255,255,1);
        padding-bottom: 20vh;
        padding-top: 10vh;
        margin-bottom: 0;
    }

    #project-content-2 .ipad {
        grid-column: 4 / 6;
        grid-row: 4 / 7;
    }

    #project-content-2 .site {
        grid-column: 2 / 5;
        grid-row: 1 / 7;
    }

    #project-content-3 {
        height: auto;
        background-image: url("../assets/img/sac/sac-bg-2.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        background-color: rgba(255,255,255,1);
        padding-bottom: 20vh;
        padding-top: 10vh;
        margin-bottom: 0;
    }

    #project-content-3 .ipad {
        grid-column: 2 / 4;
        grid-row: 2 / 7;
    }

    #project-content-3 .site {
        grid-column: 3 / 6;
        grid-row: 1 / 7;
    }

</style>
